import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { DescriptionBylineStyle } from './styles';
import { messages } from '../i18n';
export default class TeamMentionDescriptionByline extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderByline", (memberCount, includesYou) => {
      if (includesYou) {
        if (memberCount > 50) {
          return this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, messages.plus50MembersWithYou));
        }

        return this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.memberCountWithYou, {
          values: {
            0: memberCount
          }
        })));
      } else {
        if (memberCount > 50) {
          return this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, messages.plus50MembersWithoutYou));
        }

        return this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.memberCountWithoutYou, {
          values: {
            0: memberCount
          }
        })));
      }
    });

    _defineProperty(this, "getBylineComponent", message => /*#__PURE__*/React.createElement(DescriptionBylineStyle, null, message));
  }

  render() {
    const {
      context
    } = this.props.mention;

    if (!context) {
      return null;
    }

    const includesYou = context.includesYou;
    const memberCount = context.memberCount;
    return this.renderByline(memberCount, includesYou);
  }

}